import React, { useState } from 'react'
import styled from 'styled-components'

// styles
import colors from '../../styles/colors'

function Selector({
  selectedIdx,
  handleTab,
  leftText,
  rightText,
  isLeftAlign,
}) {
  return (
    <Container isLeftAlign={isLeftAlign}>
      <SelectWrapper>
        <AllAnswerWrapper
          isActive={selectedIdx === 0}
          onClick={() => handleTab(0)}
        >
          {leftText}
        </AllAnswerWrapper>
        <DivideLine />
        <UnAnswerWrapper
          isActive={selectedIdx === 1}
          onClick={() => handleTab(1)}
        >
          {rightText}
        </UnAnswerWrapper>
      </SelectWrapper>
    </Container>
  )
}

export default Selector

const Container = styled.div`
  width: ${(props) => props.isLeftAlign && '100%'};
  max-width: 768px;
  min-width: 320px;
  display: flex;
  flex-direction: row;
  margin-top: 40px;

  @media ${(props) => props.theme.mobile} {
    margin-top: 30px;
  }
`

const SelectWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50px;
  max-width: 321px;
  cursor: pointer;
`

const AllAnswerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-left: ${(props) =>
    props.isActive ? `1px solid ${colors.mainG}` : `1px solid ${colors.G3}`};
  border-top: ${(props) =>
    props.isActive ? `1px solid ${colors.mainG}` : `1px solid ${colors.G3}`};
  border-bottom: ${(props) =>
    props.isActive ? `1px solid ${colors.mainG}` : `1px solid ${colors.G3}`};
  font-size: 16px;
  color: ${(props) => (props.isActive ? `${colors.W1}` : `${colors.BK}`)};
  background-color: ${(props) =>
    props.isActive ? `${colors.mainG}` : `${colors.W1}`};

  &:hover {
    color: ${colors.W1};
    border-left: 1px solid ${colors.mainG};
    border-top: 1px solid ${colors.mainG};
    border-bottom: 1px solid ${colors.mainG};
    background-color: ${colors.mainG};
  }

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`

const DivideLine = styled.div`
  width: 1px;
  background-color: ${colors.mainG};
`

const UnAnswerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 160px;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: ${(props) =>
    props.isActive ? `1px solid ${colors.mainG}` : `1px solid ${colors.G3}`};
  border-top: ${(props) =>
    props.isActive ? `1px solid ${colors.mainG}` : `1px solid ${colors.G3}`};
  border-bottom: ${(props) =>
    props.isActive ? `1px solid ${colors.mainG}` : `1px solid ${colors.G3}`};
  font-size: 16px;
  color: ${(props) => (props.isActive ? `${colors.W1}` : `${colors.BK}`)};
  background-color: ${(props) =>
    props.isActive ? `${colors.mainG}` : `${colors.W1}`};

  &:hover {
    color: ${colors.W1};
    border-top: 1px solid ${colors.mainG};
    border-bottom: 1px solid ${colors.mainG};
    border-right: 1px solid ${colors.mainG};
    background-color: ${colors.mainG};
  }

  @media ${(props) => props.theme.mobile} {
    font-size: 14px;
  }
`
